import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import useStyles from "./styles";

const EmptyContainer = ({ description }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      minHeight={400}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <span className={classes.emptyText}>{description}</span>
    </Box>
  );
};

export default EmptyContainer;
